// extracted by mini-css-extract-plugin
export var consumerCta = "blog-tof-cta-module--consumerCta--4b557";
export var container = "blog-tof-cta-module--container--222b8";
export var divider = "blog-tof-cta-module--divider--ec195";
export var headerContent = "blog-tof-cta-module--headerContent--70e1c";
export var providerCta = "blog-tof-cta-module--providerCta--6c87b";